export default __webpack_public_path__ + "assets/images/a5c77668659f5cdcc4cd7934461de763.png";